import React from 'react';
import { Icon } from 'venn-ui-kit';
import type { CallPutEnum } from 'venn-api';
import { cn } from '@/lib/utils';

type OptionIconProps = Readonly<{
  optionType: CallPutEnum;
  inverted?: boolean;
  disabled?: boolean;
}>;

export const OPTION_ICON_CLASS = 'option-icon';

const getColorClassName = ({ inverted = false, disabled = false }: Pick<OptionIconProps, 'inverted' | 'disabled'>) => {
  if (disabled) {
    return 'text-venn-grey';
  }
  return inverted ? 'text-venn-white' : 'text-venn-grey-60';
};

export const OptionIcon = ({ optionType, inverted = false, disabled = false }: OptionIconProps) => {
  if (optionType === 'UNKNOWN') {
    return null;
  }

  return (
    <Icon
      type={optionType === 'CALL' ? 'circle-c' : 'circle-p'}
      iconLabel={optionType === 'CALL' ? 'Call option icon' : 'Put option icon'}
      className={cn(getColorClassName({ inverted, disabled }), OPTION_ICON_CLASS)}
    />
  );
};
